<template>
  <div class="addCar">
    <van-popup
      v-model="show"
      position="bottom"
      :close-on-click-overlay="false"
    >
      <div class="header">
        <div class="title">我的车辆</div>
        <van-icon name="cross" color="#383838" @click="cancel" size="0.3rem" />
      </div>
      <div class="content">
        <van-cell v-for="(item, index) in carList" @click="changeCar(item)" :key="index" :title="item.carNo" class="cell" title-class="cellTitle">
          <template #right-icon>
            <img src="@/assets/img/ticket/edit.png" @click.stop="changeInfo(item)" class="img" alt="">
          </template>
        </van-cell>
      </div>
      <div class="btn">
        <van-button type="info" size="large" v-if="carList.length < 5" @click="addCar">添加车辆</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "",
  components: {
  },
  props: {
    showAddCar: {
      type: Boolean
    },
    carList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      show: false
    }
  },
  watch: {
    showAddCar(val) {
      this.show = val
    }
  },
  methods: {
    cancel() {
      this.show =  false
      this.$emit('cancel')
    },
    changeInfo(data) {
      this.$router.push({
        path: '/carCheck',
        query: {
          phone: this.$route.query.phone,
          categoryCode: this.$route.query.categoryCode,
          productCode: this.$route.query.productCode,
          carInfo: JSON.stringify(data)
        },
      });
    },
    addCar() {
      this.$router.push({
        path: '/carCheck',
        query: {
          phone: this.$route.query.phone,
          categoryCode: this.$route.query.categoryCode,
          productCode: this.$route.query.productCode,
        },
      });
    },
    changeCar(data) {
      this.$emit('changeCar', data)
    }
  }
}
</script>
<style scoped lang="scss">
.addCar{
  .header{
    height: 1rem;
    line-height: 1rem;
    border-bottom: 1px solid #F4F6F7;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.3rem;
    box-sizing: border-box;
    .title{
      color: #383838;
      font-size: 0.32rem;
    }
  }
  .content{
    padding: 0 0.3rem;
    box-sizing: border-box;
    // overflow-y: scroll;
    // height: calc(50vh - 2.3rem);
    .cell{
      border-bottom: 1px solid #F4F6F7;
      .img{
        width: 0.4rem;
        z-index: 99999;
      }
    }
    .cellTitle{
      color: #383838;
      font-size: 0.3rem;
      font-weight: 500;
    }
  }
  .btn{
    width: 100vw;
    height: 1.8rem;
    line-height: 1.5rem;
    padding: 0 0.3rem;
    box-sizing: border-box;
    /deep/ .van-button{
      border-radius: 0.16rem;
    }
  }
}
</style>